import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './button.style.scss';

/**
 * Class representing button input.
 * @extends React.Component
 * */
class Button extends React.Component {

  /**
   * Click event trigger.
   * */
  onClick = () => {
    const { onButtonClick } = this.props;

    onButtonClick();
  };

  render() {
    const {
      buttonClass,
      fontAwesomeIcon,
      fontAwesomeSize,
      isDisabled,
      title
    } = this.props;

    return (
      <button
        className={`${buttonClass} ${isDisabled ? 'disabled' : ''}`}
        disabled={isDisabled}
        type="button"
        onClick={this.onClick}
      >
        {fontAwesomeIcon && <FontAwesomeIcon icon={fontAwesomeIcon} size={fontAwesomeSize} />}
        <span>{title}</span>
      </button>
    );
  }

}

export default Button;

Button.propTypes = {
  buttonClass: PropTypes.string,
  fontAwesomeIcon: PropTypes.shape({}),
  fontAwesomeSize: PropTypes.string,
  isDisabled: PropTypes.bool,
  onButtonClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

Button.defaultProps = {
  buttonClass: '',
  fontAwesomeIcon: null,
  fontAwesomeSize: 'lg',
  isDisabled: false,
  title: ''
};



// WEBPACK FOOTER //
// ./src/common/components/button/button.component.js